// number of prompts we fetch during each request
// used by createPromptsQuery.js, getPrompts.js
export const numberOfPromptsPerFetch = 15;
